import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=0ad786b7&scoped=true"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=js"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./ItemAutocomplete.vue?vue&type=style&index=0&id=0ad786b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad786b7",
  null
  
)

export default component.exports
import {QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect})
